import React from 'react';
import { Link } from 'react-router-dom';

export default function TeachersDocs({ topic, setTopic, userInfo, schoolType }) {
	const isSupervisor = userInfo && `${userInfo.role_id}` === '3';
	const validTopics = ['search_teachers', 'upload_teachers', 'sort_teachers', 'filter_by_department', 'add_teacher', 'edit_teacher', 'select_rows', 'delete_teachers'].filter(topic_option => !isSupervisor || !['upload_teachers', 'add_teacher'].includes(topic_option));
	const teachersTopic = validTopics.includes(topic) ? topic : 'default';

	const chooseTeachersTopic = (newTopic) => {
		if (teachersTopic === newTopic) {
			setTopic(null);
		} else {
			setTopic(newTopic);
		}
	};

	const videoPlaceholder = { backgroundColor: '#000', borderRadius: '8px', color: '#fff', minHeight: '240px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '20px', padding: '20px', textAlign: 'center' };

	return (
		<div className='documentation-page'>
			<div className='step-main-heading'>Teachers</div>
			<p className='documentation-question-heading'>What do you need help with?</p>
			<div className='choose-topic'>
				<Link className={`choose-topic-btn ${teachersTopic === 'search_teachers' ? 'choose-topic-btn-selected' : ''}`} to={`/app/${schoolType}/documentation/school_data/teachers/${teachersTopic === 'search_teachers' ? 'null' : 'search_teachers'}`} onClick={() => chooseTeachersTopic('search_teachers')}>Search Teachers</Link>
				{!isSupervisor && <Link className={`choose-topic-btn ${teachersTopic === 'upload_teachers' ? 'choose-topic-btn-selected' : ''}`} to={`/app/${schoolType}/documentation/school_data/teachers/${teachersTopic === 'upload_teachers' ? 'null' : 'upload_teachers'}`} onClick={() => chooseTeachersTopic('upload_teachers')}>Upload Teachers</Link>}
				<Link className={`choose-topic-btn ${teachersTopic === 'sort_teachers' ? 'choose-topic-btn-selected' : ''}`} to={`/app/${schoolType}/documentation/school_data/teachers/${teachersTopic === 'sort_teachers' ? 'null' : 'sort_teachers'}`} onClick={() => chooseTeachersTopic('sort_teachers')}>Sort Teacher Data</Link>
				<Link className={`choose-topic-btn ${teachersTopic === 'filter_by_department' ? 'choose-topic-btn-selected' : ''}`} to={`/app/${schoolType}/documentation/school_data/teachers/${teachersTopic === 'filter_by_department' ? 'null' : 'filter_by_department'}`} onClick={() => chooseTeachersTopic('filter_by_department')}>Filter By Department</Link>
				{!isSupervisor && <Link className={`choose-topic-btn ${teachersTopic === 'add_teacher' ? 'choose-topic-btn-selected' : ''}`} to={`/app/${schoolType}/documentation/school_data/teachers/${teachersTopic === 'add_teacher' ? 'null' : 'add_teacher'}`} onClick={() => chooseTeachersTopic('add_teacher')}>Add A Teacher</Link>}
				<Link className={`choose-topic-btn ${teachersTopic === 'edit_teacher' ? 'choose-topic-btn-selected' : ''}`} to={`/app/${schoolType}/documentation/school_data/teachers/${teachersTopic === 'edit_teacher' ? 'null' : 'edit_teacher'}`} onClick={() => chooseTeachersTopic('edit_teacher')}>Edit A Teacher</Link>
				<Link className={`choose-topic-btn ${teachersTopic === 'select_rows' ? 'choose-topic-btn-selected' : ''}`} to={`/app/${schoolType}/documentation/school_data/teachers/${teachersTopic === 'select_rows' ? 'null' : 'select_rows'}`} onClick={() => chooseTeachersTopic('select_rows')}>Select Teacher Rows</Link>
				<Link className={`choose-topic-btn ${teachersTopic === 'delete_teachers' ? 'choose-topic-btn-selected' : ''}`} to={`/app/${schoolType}/documentation/school_data/teachers/${teachersTopic === 'delete_teachers' ? 'null' : 'delete_teachers'}`} onClick={() => chooseTeachersTopic('delete_teachers')}>Delete Teachers</Link>
			</div>

			{teachersTopic === 'search_teachers' &&
				<div className='documentation-container'>
					<h2 className='documentation-page-heading'>Search Teachers</h2>
					<div className='documentation-step-text'>Use the search bar to find teachers by last name, first name, or teacher code.</div>
					<div style={videoPlaceholder}>Video tutorial coming soon!</div>
				</div>
			}
			{teachersTopic === 'upload_teachers' &&
				<div className='documentation-container'>
					<h2 className='documentation-page-heading'>Upload Teachers</h2>
					<div className='documentation-step-text'>Use the Upload button to import teacher data with the upload modal.</div>
					<div style={videoPlaceholder}>Video tutorial coming soon!</div>
				</div>
			}
			{teachersTopic === 'sort_teachers' &&
				<div className='documentation-container'>
					<h2 className='documentation-page-heading'>Sort Teacher Data</h2>
					<div className='documentation-step-text'>Sort by Last Name or First Name from the column headers.</div>
					<div style={videoPlaceholder}>Video tutorial coming soon!</div>
				</div>
			}
			{teachersTopic === 'filter_by_department' &&
				<div className='documentation-container'>
					<h2 className='documentation-page-heading'>Filter By Department</h2>
					<div className='documentation-step-text'>Use the Department(s) filter to narrow teacher records to selected departments.</div>
					<div style={videoPlaceholder}>Video tutorial coming soon!</div>
				</div>
			}
			{teachersTopic === 'add_teacher' &&
				<div className='documentation-container'>
					<h2 className='documentation-page-heading'>Add A Teacher</h2>
					<div className='documentation-step-text'>Click the plus button in the header row to create a new teacher.</div>
					<div style={videoPlaceholder}>Video tutorial coming soon!</div>
				</div>
			}
			{teachersTopic === 'edit_teacher' &&
				<div className='documentation-container'>
					<h2 className='documentation-page-heading'>Edit A Teacher</h2>
					<div className='documentation-step-text'>Click the edit icon on a teacher row to open and update that record.</div>
					<div style={videoPlaceholder}>Video tutorial coming soon!</div>
				</div>
			}
			{teachersTopic === 'select_rows' &&
				<div className='documentation-container'>
					<h2 className='documentation-page-heading'>Select Teacher Rows</h2>
					<div className='documentation-step-text'>Select one or multiple teachers, or use Select All for bulk actions.</div>
					<div style={videoPlaceholder}>Video tutorial coming soon!</div>
				</div>
			}
			{teachersTopic === 'delete_teachers' &&
				<div className='documentation-container'>
					<h2 className='documentation-page-heading'>Delete Teachers</h2>
					<div className='documentation-step-text'>Delete one or many selected teachers with confirmation and optional prompt suppression.</div>
					<div style={videoPlaceholder}>Video tutorial coming soon!</div>
				</div>
			}
		</div>
	);
}
